"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountGradeForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="account-grade-form-page">
        <div class="row">
            <div class="col-lg-8 col-12 pb-lg-5">
                <div class="mb-2">
                    <h1>${x => x.accountGradeId ? 'accountGrade.form.title.edit'.t() : 'accountGrade.form.title.add'.t()}</h1>
                    <div class="text-zero top-right-button-container">
                        <button @click="${(x, c) => x.goBack()}" type="button"
                            class="top-right-button mr-1 btn btn-primary btn-lg">${'common.back'.t()}</button>
                    </div>
                </div>
                <div class="card card-body mb-5">
                    <the-form :onSubmit="${(x, c) => x.handleSubmit.bind(x)}">
                        
                        <h5 class="mb-3">${'accountGrade.basicInfo'.t()}</h5>
                        <div class="form-group">
                            <part-input required="true" class="form-part" label="${'accountGrade.name'.t()}"
                                :value="${x => x.form.name}" name="name" placeholder="${'accountGrade.form.name.placeholder'.t()}"
                                required="true"></part-input>
                        </div>
                        <div class="form-group">
                            <part-textarea class="form-part" label="${'accountGrade.description'.t()}"
                                :value="${x => x.form.description}" name="description" 
                                placeholder="${'accountGrade.form.description.placeholder'.t()}"></part-textarea>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-3">
                                <part-input required="true" class="form-part" label="${'accountGrade.price'.t()}"
                                    :value="${x => x.form.price !== null && x.form.price !== undefined ? x.form.price.toString() : ''}" 
                                    name="price" type="number" step="0.01" min="0"
                                    placeholder="${'accountGrade.form.price.placeholder'.t()}"></part-input>
                                <small class="form-text text-muted">${'accountGrade.form.price.monthly.help'.t()}</small>
                            </div>
                            <div class="form-group col-md-3">
                                <part-input required="true" class="form-part" label="${'accountGrade.yearlyPrice'.t()}"
                                    :value="${x => x.form.yearlyPrice !== null && x.form.yearlyPrice !== undefined ? x.form.yearlyPrice.toString() : ''}" 
                                    name="yearlyPrice" type="number" step="0.01" min="0"
                                    placeholder="${'accountGrade.form.yearlyPrice.placeholder'.t()}"></part-input>
                                <small class="form-text text-muted">${'accountGrade.form.yearlyPrice.help'.t()}</small>
                            </div>
                            <div class="form-group col-md-3">
                                <part-input class="form-part" label="${'accountGrade.creditsPerMonth'.t()}"
                                    :value="${x => x.form.creditsPerMonth !== null && x.form.creditsPerMonth !== undefined ? x.form.creditsPerMonth.toString() : ''}" 
                                    name="creditsPerMonth" type="number" min="0"
                                    placeholder="${'accountGrade.form.creditsPerMonth.placeholder'.t()}"></part-input>
                                <small class="form-text text-muted">${'accountGrade.form.creditsPerMonth.help'.t()}</small>
                            </div>
                             <div class="form-group col-md-3">                                
                                <icon-picker 
                                    placeholder="${'project.form.icon.placeholder'.t()}"
                                    :value="${x => x.form.icon}"
                                    @icon-changed="${(x, c) => x.handleIconChange(c.event)}"
                                ></icon-picker>                  
                            </div>
                        </div>

                        
                        <h5 class="mb-3 mt-4">${'accountGrade.limits'.t()}</h5>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <strong>${'accountGrade.maxUsers'.t()}</strong>
                                ${(0, fast_element_1.when)(x => x.form.maxUsers !== null, (0, fast_element_1.html) `
                                    <part-input class="form-part mt-2"
                                        :value="${x => x.form.maxUsers !== null ? x.form.maxUsers.toString() : ''}" name="maxUsers" type="number" 
                                        placeholder="${'accountGrade.form.maxUsers.placeholder'.t()}"></part-input>
                                `)}
                                <part-checkbox class="form-part mt-2" label="${'accountGrade.unlimited'.t()}" 
                                    :value="${x => x.form.maxUsers === null}" name="unlimitedMaxUsers">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-6">
                                <strong>${'accountGrade.maxAvatars'.t()}</strong>
                                ${(0, fast_element_1.when)(x => x.form.maxAvatars !== null, (0, fast_element_1.html) `
                                    <part-input class="form-part mt-2"
                                        :value="${x => x.form.maxAvatars !== null ? x.form.maxAvatars.toString() : ''}" name="maxAvatars" type="number" 
                                        placeholder="${'accountGrade.form.maxAvatars.placeholder'.t()}"></part-input>
                                `)}
                                <part-checkbox class="form-part mt-2" label="${'accountGrade.unlimited'.t()}" 
                                    :value="${x => x.form.maxAvatars === null}" name="unlimitedMaxAvatars">
                                </part-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <strong>${'accountGrade.maxProjectsCount'.t()}</strong>
                                ${(0, fast_element_1.when)(x => x.form.maxProjectsCount !== null, (0, fast_element_1.html) `
                                    <part-input class="form-part mt-2"
                                        :value="${x => x.form.maxProjectsCount !== null ? x.form.maxProjectsCount.toString() : ''}" name="maxProjectsCount" type="number" 
                                        placeholder="${'accountGrade.form.maxProjectsCount.placeholder'.t()}"></part-input>
                                `)}
                                <part-checkbox class="form-part mt-2" label="${'accountGrade.unlimited'.t()}" 
                                    :value="${x => x.form.maxProjectsCount === null}" name="unlimitedMaxProjectsCount">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-6">
                                <strong>${'accountGrade.maxKnowledgeEntries'.t()}</strong>
                                ${(0, fast_element_1.when)(x => x.form.maxKnowledgeEntries !== null, (0, fast_element_1.html) `
                                    <part-input class="form-part mt-2"
                                        :value="${x => x.form.maxKnowledgeEntries !== null ? x.form.maxKnowledgeEntries.toString() : ''}" name="maxKnowledgeEntries" type="number" 
                                        placeholder="${'accountGrade.form.maxKnowledgeEntries.placeholder'.t()}"></part-input>
                                `)}
                                <part-checkbox class="form-part mt-2" label="${'accountGrade.unlimited'.t()}" 
                                    :value="${x => x.form.maxKnowledgeEntries === null}" name="unlimitedMaxKnowledgeEntries">
                                </part-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <strong>${'accountGrade.customAiModels'.t()}</strong>
                                ${(0, fast_element_1.when)(x => x.form.customAiModels !== null, (0, fast_element_1.html) `
                                    <part-input class="form-part mt-2"
                                        :value="${x => x.form.customAiModels !== null ? x.form.customAiModels.toString() : ''}" name="customAiModels" type="number" 
                                        placeholder="${'accountGrade.form.customAiModels.placeholder'.t()}"></part-input>
                                `)}
                                <part-checkbox class="form-part mt-2" label="${'accountGrade.unlimited'.t()}" 
                                    :value="${x => x.form.customAiModels === null}" name="unlimitedCustomAiModels">
                                </part-checkbox>
                            </div>
                        </div>

                        
                        <h5 class="mb-3 mt-4">${'accountGrade.features'.t()}</h5>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.advancedPrompts'.t()}" 
                                    :value="${x => x.form.advancedPrompts}" name="advancedPrompts">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.promptAssist'.t()}" 
                                    :value="${x => x.form.promptAssist}" name="promptAssist">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.antiHallucination'.t()}" 
                                    :value="${x => x.form.antiHallucination}" name="antiHallucination">
                                </part-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.advancedReports'.t()}" 
                                    :value="${x => x.form.advancedReports}" name="advancedReports">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.chatThreadSharing'.t()}" 
                                    :value="${x => x.form.chatThreadSharing}" name="chatThreadSharing">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.customBranding'.t()}" 
                                    :value="${x => x.form.customBranding}" name="customBranding">
                                </part-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.widgets'.t()}" 
                                    :value="${x => x.form.widgets}" name="widgets">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.voiceAgent'.t()}" 
                                    :value="${x => x.form.voiceAgent}" name="voiceAgent">
                                </part-checkbox>
                            </div>
                            <div class="form-group col-md-4">
                                <part-checkbox class="form-part" label="${'accountGrade.writingStyles'.t()}" 
                                    :value="${x => x.form.writingStyles}" name="writingStyles">
                                </part-checkbox>
                            </div>
                        </div>
                        
                        
                        <div class="form-group mt-4">
                            <part-checkbox class="form-part" label="${'common.active'.t()}" 
                                :value="${x => x.form.active}" name="active">
                            </part-checkbox>
                        </div>
                        
                        <div class="form-group mt-4">
                            <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                                ?disabled="${x => x.loading}">
                                ${x => x.accountGradeId ? 'accountGrade.form.submit.update'.t() : 'accountGrade.form.submit.create'.t()}
                            </button>
                        </div>
                    </the-form>
                </div>
            </div>
        </div>
    </div>
    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let AccountGradeForm = class AccountGradeForm extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.accountGradeId = null;
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
        this.initializeForm();
    }
    initializeForm() {
        this.form = {
            name: '',
            description: '',
            price: 0,
            yearlyPrice: 0,
            creditsPerMonth: 0,
            advancedPrompts: false,
            promptAssist: false,
            maxAvatars: 1,
            maxUsers: 1,
            maxProjectsCount: 1,
            maxKnowledgeEntries: 1,
            antiHallucination: false,
            advancedReports: false,
            chatThreadSharing: false,
            customBranding: false,
            widgets: false,
            customAiModels: 1,
            voiceAgent: false,
            writingStyles: false,
            active: true
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        // Handle form-part events
        this.on(events_1.inputEvents.changed, (event) => {
            this.handlePartChange(event.detail);
        });
        // Get account grade ID from route params
        const params = this.getRouteParams();
        if (params === null || params === void 0 ? void 0 : params.id) {
            this.accountGradeId = params.id;
            await this.loadAccountGrade();
        }
    }
    getRouteParams() {
        const path = window.location.pathname;
        const segments = path.split('/');
        const formIndex = segments.indexOf('form');
        if (formIndex !== -1 && segments[formIndex + 1]) {
            return { id: segments[formIndex + 1] };
        }
        return null;
    }
    handlePartChange(payload) {
        const { fieldName, value } = payload;
        // Handle unlimited checkboxes
        if (fieldName === 'unlimitedMaxUsers') {
            this.form = { ...this.form, maxUsers: value ? null : 1 };
            return;
        }
        if (fieldName === 'unlimitedMaxAvatars') {
            this.form = { ...this.form, maxAvatars: value ? null : 1 };
            return;
        }
        if (fieldName === 'unlimitedMaxProjectsCount') {
            this.form = { ...this.form, maxProjectsCount: value ? null : 1 };
            return;
        }
        if (fieldName === 'unlimitedMaxKnowledgeEntries') {
            this.form = { ...this.form, maxKnowledgeEntries: value ? null : 1 };
            return;
        }
        if (fieldName === 'unlimitedCustomAiModels') {
            this.form = { ...this.form, customAiModels: value ? null : 1 };
            return;
        }
        // Handle number inputs
        if (['maxUsers', 'maxAvatars', 'maxProjectsCount', 'maxKnowledgeEntries', 'customAiModels'].includes(fieldName)) {
            const numValue = value !== null && value !== undefined && value !== '' ? parseInt(value.toString()) : null;
            this.form = { ...this.form, [fieldName]: numValue };
            return;
        }
        // Handle price
        if (fieldName === 'price') {
            const priceValue = value !== null && value !== undefined && value !== '' ? parseFloat(value.toString()) : 0;
            this.form = { ...this.form, price: isNaN(priceValue) ? 0 : priceValue };
            return;
        }
        // Handle yearly price
        if (fieldName === 'yearlyPrice') {
            const priceValue = value !== null && value !== undefined && value !== '' ? parseFloat(value.toString()) : 0;
            this.form = { ...this.form, yearlyPrice: isNaN(priceValue) ? 0 : priceValue };
            return;
        }
        // Handle creditsPerMonth
        if (fieldName === 'creditsPerMonth') {
            const creditsValue = value !== null && value !== undefined && value !== '' ? parseInt(value.toString()) : 0;
            this.form = { ...this.form, creditsPerMonth: isNaN(creditsValue) ? 0 : creditsValue };
            return;
        }
        // Handle regular form fields
        if (fieldName in this.form) {
            this.form = { ...this.form, [fieldName]: value };
        }
    }
    handleIconChange(event) {
        this.form = { ...this.form, icon: event.detail.value };
    }
    async loadAccountGrade() {
        if (!this.accountGradeId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('accountGrade.get', {
                routeParams: { id: this.accountGradeId }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                // Intake the whole IAccountGrade data, excluding system fields and relations
                const { id, created_at, updated_at, order, users, payments, stripeProductId, stripePriceId, stripeYearlyProductId, stripeYearlyPriceId, ...formData } = response.data;
                this.form = formData;
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'accountGrade.loadError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Load error:', error);
            this.notifyService.notify('accountGrade.loadError'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async handleSubmit(event) {
        this.loading = true;
        try {
            const endpoint = this.accountGradeId ? 'accountGrade.update' : 'accountGrade.create';
            const routeParams = this.accountGradeId ? { id: this.accountGradeId } : undefined;
            const response = await this.apiService.back[this.accountGradeId ? 'put' : 'post'](endpoint, this.form, { routeParams });
            if (response && response.success) {
                this.notifyService.notify(this.accountGradeId ? 'accountGrade.form.updateSuccess'.t() : 'accountGrade.form.createSuccess'.t(), 'info');
                this.goBack();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'accountGrade.form.saveError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Save error:', error);
            this.notifyService.notify('accountGrade.form.saveError'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    goBack() {
        component_2.SiteMenu.goto.bind(this)('/settings/account-grade/list');
    }
};
exports.AccountGradeForm = AccountGradeForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountGradeForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AccountGradeForm.prototype, "accountGradeId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Partial !== "undefined" && Partial) === "function" ? _b : Object)
], AccountGradeForm.prototype, "form", void 0);
exports.AccountGradeForm = AccountGradeForm = __decorate([
    (0, client_1.RWSView)('account-grade-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], AccountGradeForm);
AccountGradeForm.defineComponent();
